import { categoryService } from '../../helpers/services/category.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CATEGORY_MODULE = 'category'; 

// define action 
export const GET_ALL_CATEGORIES = 'getAllCategories';
export const GET_CATEGORY = 'getCategory';
export const UPDATE_CATEGORY = 'updateCategory';
export const CREATE_CATEGORY = 'createCategory';
export const UPDATE_CATEGORY_STATUS = 'updateCategoryStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CATEGORIES_REQUEST = "getAllCategories";
const GET_CATEGORY_REQUEST = "getCategory";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CATEGORIES]({ commit }, { filter }) {
        categoryService
            .getAllCategories(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CATEGORIES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_CATEGORY]({ commit }, { id }) {
       await categoryService
            .getCategory(id)
            .then(
                (result) => {
                    commit(GET_CATEGORY_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CATEGORY]({ commit }, { data }) {
        commit(REQUEST)
        categoryService
            .updateCategory(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.category')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CATEGORY]({ commit }, { data }) {
        commit(REQUEST)
        categoryService
            .createCategory(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.category')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CATEGORY_STATUS]({ dispatch }, { filter, data }) {
        categoryService
            .updateCategoryStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CATEGORIES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Category-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_CATEGORIES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_CATEGORY_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }


    }
}


